'use strict';

var Radio = require('backbone.radio');
var Marionette = require('backbone.marionette');

var TimezonePickerContainerView = require('../timezone-picker/timezone-container').default;

export default Marionette.View.extend({

  tagName: 'div',
  className: 'timezone-modal-container',
  template: require('./templates/modal.hbs'),

  regions: {
    container: {
      el: ".timezone-container",
      replaceElement: true,
    },
  },

  onTimezoneSearch: function(searchVal) {
    this.picker.setQuery(searchVal);
  },

  initialize: function () {
    this.container = new TimezonePickerContainerView();

    this.listenTo(this.container, 'change', this.onCloseModal);
    this.listenTo(this.container, 'closeTimezonePicker', this.onCloseModal);
    this.listenTo(Radio.channel('windows'), 'close', this.onCloseModal);
  },

  onRender: function () {
    this.showChildView('container', this.container);
  },

  onCloseModal: function () {
    Radio.channel('modal').trigger('hide');
    Radio.channel('windows').trigger('focusWaitlist');
  },

});
